import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Message } from "element-ui";
import { upplatform, addPlatform, upplatforms } from "@/api/Administration/advertisement"; // import  {advAdd} from "@/api/Administration/advertisement";

export default {
  props: {
    showing: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var _this = this;

    var validate = function validate(rule, value, callback) {
      if (value === '') {
        callback(new Error(_this.$t('pleaseInput')));
      } else if (/[A-Z\u4e00-\u9fa5]/.test(value)) {
        callback(new Error(_this.$t('cannotContainUppercaseChinese')));
      } else {
        callback();
      }
    };

    return {
      dialogFormVisible: false,
      titleNameKey: "",
      id: "",
      form: {
        adv_platform_name: "",
        status: "1",
        adv_platform_mark: ""
      },
      makeForm: {
        adv_platform_name: "",
        status: "1",
        adv_platform_mark: ""
      },
      rules: {
        adv_platform_name: [{
          required: true,
          message: this.$t('pleaseInputAdPlatformName'),
          trigger: "blur"
        }],
        adv_platform_mark: [{
          required: true,
          validator: validate,
          trigger: "blur"
        }]
      },
      formLabelWidth: "130px"
    };
  },
  created: function created() {},
  computed: {
    isShow: {
      get: function get() {
        if (this.showing) {
          return this.showing;
        }
      },
      set: function set(val) {
        this.$emit("changeShow", false);
      }
    }
  },
  methods: {
    // 打开修改新增
    init: function init(id, num) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var tid, _yield$upplatforms, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.dialogFormVisible = true;

                if (num == 1) {
                  _this2.titleNameKey = "addAdPlatform";
                }

                _this2.id = id;

                if (!(id != "t")) {
                  _context.next = 14;
                  break;
                }

                if (!(num == 2)) {
                  _context.next = 14;
                  break;
                }

                _this2.titleNameKey = "modifyAdPlatform";
                tid = {
                  id: id
                };
                _context.next = 9;
                return upplatforms(tid);

              case 9:
                _yield$upplatforms = _context.sent;
                data = _yield$upplatforms.data;
                _this2.form.status = String(data.status);
                _this2.form.adv_platform_mark = data.adv_platform_mark;
                _this2.form.adv_platform_name = data.adv_platform_name;

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 关闭弹窗或取消修改新增
    resetForm: function resetForm(formName) {
      this.dialogFormVisible = false;
      this.$emit("changeShow", false);
      this.form = _objectSpread({}, this.makeForm);
      this.$refs.ruleForm.clearValidate();
    },
    // 确定添加修改
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this3 = this;

      this.$refs.ruleForm.validate(function (vali) {
        if (vali) {
          if (_this3.titleNameKey == "addAdPlatform") {
            _this3.form.id = null;
            addPlatform(_this3.form).then(function (res) {
              if (res.status == 200) {
                Message.success(_this3.$t('operationSuccess'));

                _this3.$emit("refreshDataList");

                _this3.resetForm("ruleForm");
              }
            });
          }

          if (_this3.titleNameKey == "modifyAdPlatform") {
            _this3.form.id = _this3.id;
            upplatform({
              adv_platform_name: _this3.form.adv_platform_name,
              adv_platform_mark: _this3.form.adv_platform_mark,
              id: _this3.form.id,
              status: String(_this3.form.status)
            }).then(function (res) {
              if (res.status == 200) {
                Message.success(_this3.$t('operationSuccess'));

                _this3.$emit("refreshDataList");

                _this3.resetForm("ruleForm");
              }
            });
          }
        }
      });
    }
  }
};